import {
	CARRIER_ROLLSET_DATA_INITIAL_VALUES,
	CarrierRollsetData,
} from "./CarrierRollsetData";
import { Part, PART_INITIAL_VALUES } from "./Part";

export interface Donut extends Part, CarrierRollsetData {
	DonutStatusCode: string;
	Diameter: number | null;
	NewDiameter: number | null;
	ScrapDiameter: number | null;
	Width: number | null;
	SectionFamilyId: number | null;
	SectionFamilyName: string | null;
	IsActive: boolean | null;
	// Universal Roll info
	UniversalRollPartId: number | null;
	UniversalRollName: string | null;
}

export const DONUT_INITIAL_VALUES: Donut = {
	...PART_INITIAL_VALUES,
	DonutStatusCode: "R",
	Diameter: null,
	NewDiameter: null,
	ScrapDiameter: null,
	Width: null,
	SectionFamilyId: null,
	SectionFamilyName: "",
	IsActive: true,
	// Universal Roll info
	UniversalRollPartId: null,
	UniversalRollName: null,
	...CARRIER_ROLLSET_DATA_INITIAL_VALUES,
};
